import { Reducer } from 'redux';
import { IReloadListState, IReloadListAction } from './types';

const initialState = {
  reloadList: false,
}

const ReloadListReducer: Reducer<IReloadListState> = ((state:IReloadListState = initialState, action) => {
  switch((action as IReloadListAction).type) {
    case "RELOAD_LIST": {
      return { ...state, reloadList: action.payload}
    }
    default:
      return state
  }
});

export default ReloadListReducer;